import { Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { LocalStorage } from '../local-storage/local-storage.service';
import { environment } from '../../../../environments/environment';
import { ThemeEnum } from './models/enums/theme.enum';
import { PrimeNG } from 'primeng/config';

export const THEME_STORAGE_KEY = environment.keys.theme;
export const THEME_DARK_MODE_SELECTOR = '.dark';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  constructor(
    private readonly primeNg: PrimeNG,
    private readonly localStorage: LocalStorage,
  ) { }

  private readonly _theme: WritableSignal<ThemeEnum> = signal(ThemeEnum.DARK);

  public get theme(): Signal<ThemeEnum> {
    return this._theme;
  }

  public set theme(theme: ThemeEnum) {
    this.localStorage.setItem(environment.keys.theme, theme);
    this._theme.set(theme);

    this.loadTheme(theme);
  }

  public initialize(): void {
    const storedTheme = this.localStorage.getItem<ThemeEnum>(environment.keys.theme);
    this.theme = storedTheme ?? ThemeEnum.DARK;
  }

  private loadTheme(theme: ThemeEnum): void {
    const element = document.documentElement;
    const isDark = theme === ThemeEnum.DARK;

    element.classList.toggle(ThemeEnum.DARK, isDark);
    document.body.classList.toggle(ThemeEnum.DARK, isDark);

    this.primeNg.theme.set({
      darkModeSelector: isDark ? THEME_DARK_MODE_SELECTOR : false,
    });
  }

}
